
function huskaToggleMenu(){var n=document.getElementById('navlinks');if(n)n.classList.toggle('mobile-open');}
document.addEventListener('DOMContentLoaded',function(){
  // colorway swatch active state
  document.querySelectorAll('.swatches .sw').forEach(function(sw){
    sw.addEventListener('click',function(){
      var p=sw.closest('.swatches');if(!p)return;
      p.querySelectorAll('.sw').forEach(function(s){s.classList.remove('is-active')});
      sw.classList.add('is-active');
    });
  });
});
